(() => {
  function init(root) {
    if (root.dataset.journalInitialized === 'true') return;
    root.dataset.journalInitialized = 'true';

    /* ========================================
       CATEGORY TABS
    ======================================== */

    const tabs = [...root.querySelectorAll('[data-tab]')];
    const all = root.querySelector('[data-all-panel]');
    const panels = [...root.querySelectorAll('[data-category-panel]')];

    const choose = key => {
      tabs.forEach(tab => {
        const active = tab.dataset.tab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      if (all) all.hidden = key !== 'all';

      panels.forEach(panel => {
        panel.hidden = panel.dataset.categoryPanel !== key;
      });
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        choose(tab.dataset.tab);
      });
    });

    /* ========================================
       SELECT CATEGORY LINKS
    ======================================== */

    root.querySelectorAll('[data-select-category]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();

        const category = link.dataset.selectCategory;
        choose(category);

        const tabNav = root.querySelector('.arkt-journal__tabs');

        if (tabNav) {
          const headerHeight =
            document.querySelector('header')?.offsetHeight || 0;

          const top =
            tabNav.getBoundingClientRect().top +
            window.scrollY -
            headerHeight -
            20;

          window.scrollTo({
            top,
            behavior: 'smooth'
          });
        }
      });
    });

    /* ========================================
       LOAD MORE
    ======================================== */

    panels.forEach(panel => {
      const button = panel.querySelector('[data-load-more]');
      if (!button) return;

      let page = 2;
      let busy = false;

      const error = panel.querySelector('[data-load-error]');

      button.addEventListener('click', async () => {
        if (busy) return;

        busy = true;
        button.disabled = true;
        button.textContent = '読み込み中…';

        if (error) error.hidden = true;

        try {
          const url = new URL(
            panel.dataset.blogUrl,
            location.origin
          );

          url.searchParams.set('view', 'arkt-journal-page');
          url.searchParams.set('page', String(page));

          const response = await fetch(url.toString(), {
            credentials: 'same-origin'
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const doc = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          const cards = [
            ...doc.querySelectorAll('.arkt-journal__card')
          ];

          if (!cards.length) {
            button.parentElement.hidden = true;
            return;
          }

          const grid = panel.querySelector('[data-card-grid]');

          cards.forEach(card => {
            grid.appendChild(document.importNode(card, true));
          });

          page++;

          if (cards.length < 9) {
            button.parentElement.hidden = true;
          } else {
            button.disabled = false;
            button.innerHTML = 'もっと見る <span>＋</span>';
          }

        } catch (errorObject) {
          if (error) error.hidden = false;

          button.disabled = false;
          button.innerHTML = 'もっと見る <span>＋</span>';

          console.error('ARKT Journal:', errorObject);

        } finally {
          busy = false;
        }
      });
    });

    /* ========================================
       INFINITE HERO SLIDER
       CLONE TRACK METHOD
    ======================================== */

    const slider = root.querySelector('[data-slider]');
    const track = slider?.querySelector('[data-slider-track]');

    if (!slider || !track) return;

    // 既存の複製スライドがあれば削除
    track.querySelectorAll('[data-clone]').forEach(el => {
      el.remove();
    });

    const originalSlides = [
      ...track.querySelectorAll('[data-slide]')
    ];

    const total = originalSlides.length;

    if (!total) return;

    const prev = slider.querySelector('[data-prev]');
    const next = slider.querySelector('[data-next]');
    const dots = slider.querySelector('[data-dots]');

    let index = 0;
    let moving = false;
    let moveTimer = null;

    const duration = 550;
    const easing = 'cubic-bezier(.22,.61,.36,1)';

    const transitionValue =
      `transform ${duration}ms ${easing}`;

    /* ========================================
       SLIDE CLONES
    ======================================== */

    if (total > 1) {
      // 前後に1セットずつ複製
      const beforeFragment = document.createDocumentFragment();
      const afterFragment = document.createDocumentFragment();

      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'true';
        beforeFragment.appendChild(clone);
      });

      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'true';
        afterFragment.appendChild(clone);
      });

      track.insertBefore(beforeFragment, track.firstChild);
      track.appendChild(afterFragment);

      // 中央セットの1枚目から開始
      index = total;

    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      if (dots) dots.hidden = true;
    }

    const slides = [
      ...track.querySelectorAll('[data-slide]')
    ];

    /* ========================================
       RESET OLD POSITION STYLES
    ======================================== */

    // CSSの古い絶対配置指定を上書き
    track.style.setProperty('display', 'flex', 'important');
    track.style.setProperty('position', 'relative', 'important');
    track.style.setProperty('width', '100%', 'important');
    track.style.setProperty('height', 'auto', 'important');
    track.style.setProperty('aspect-ratio', 'auto', 'important');
    track.style.setProperty('gap', '0', 'important');
    track.style.setProperty('will-change', 'transform');

    slides.forEach(slide => {
      slide.style.setProperty('position', 'relative', 'important');
      slide.style.setProperty('top', 'auto', 'important');
      slide.style.setProperty('left', 'auto', 'important');
      slide.style.setProperty('transform', 'none', 'important');
      slide.style.setProperty('height', 'auto', 'important');
      slide.style.setProperty('flex', '0 0 60%', 'important');
      slide.style.setProperty('aspect-ratio', '1040 / 700', 'important');
      slide.style.setProperty('transition', 'opacity 0.45s ease', 'important');

      slide.classList.remove('is-prev', 'is-next');
    });

    /* ========================================
       REAL INDEX
    ======================================== */

    function realIndex() {
      if (total <= 1) return 0;
      return ((index - total) % total + total) % total;
    }

    /* ========================================
       DOTS
    ======================================== */

    if (dots) dots.innerHTML = '';

    const dotButtons = originalSlides.map((_, i) => {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.setAttribute(
        'aria-label',
        `記事 ${i + 1} を表示`
      );

      dot.addEventListener('click', () => {
        if (moving || total <= 1) return;

        const current = realIndex();
        if (current === i) return;

        const forward = (i - current + total) % total;
        const backward = (current - i + total) % total;

        // 最短方向へ1枚ずつ移動
        move(forward <= backward ? 1 : -1);
      });

      dots?.appendChild(dot);
      return dot;
    });

    /* ========================================
       POSITION
    ======================================== */

    function setPosition(animate = true) {
      const slide = slides[index];
      if (!slide) return;

      // CSSに transform:none!important が残っていても動作するようにする
      track.style.setProperty(
        'transition',
        animate ? transitionValue : 'none',
        'important'
      );

      const offset =
        slide.offsetLeft +
        slide.offsetWidth / 2 -
        slider.clientWidth / 2;

      track.style.setProperty(
        'transform',
        `translate3d(${-offset}px, 0, 0)`,
        'important'
      );

      slides.forEach((item, i) => {
        const active = i === index;

        item.classList.toggle('is-active', active);
        item.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );
      });

      dotButtons.forEach((dot, i) => {
        const active = i === realIndex();

        dot.classList.toggle('is-active', active);
        dot.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );
      });
    }

    /* ========================================
       FINISH MOVE
    ======================================== */

    function finishMove() {
      if (!moving) return;

      clearTimeout(moveTimer);
      moveTimer = null;

      // 右端の複製セットに入った場合
      if (index >= total * 2) {
        index -= total;
        setPosition(false);
      }

      // 左端の複製セットに入った場合
      else if (index < total) {
        index += total;
        setPosition(false);
      }

      moving = false;
    }

    /* ========================================
       MOVE
    ======================================== */

    function move(direction) {
      if (moving || total <= 1 || direction === 0) return;

      moving = true;
      index += direction > 0 ? 1 : -1;

      setPosition(true);

      // transitionendが発火しない場合の保険
      clearTimeout(moveTimer);

      moveTimer = setTimeout(() => {
        finishMove();
      }, duration + 100);
    }

    /* ========================================
       TRANSITION END
    ======================================== */

    track.addEventListener('transitionend', event => {
      if (
        event.target !== track ||
        event.propertyName !== 'transform'
      ) return;

      finishMove();
    });

    /* ========================================
       ARROWS
    ======================================== */

    prev?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      move(-1);
    });

    next?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      move(1);
    });

    /* ========================================
       CLICK NEIGHBOR SLIDES
    ======================================== */

    slides.forEach((slide, i) => {
      slide.addEventListener('click', event => {
        if (moving) {
          event.preventDefault();
          return;
        }

        if (i === index) return;

        event.preventDefault();

        if (i > index) {
          move(1);
        } else {
          move(-1);
        }
      });
    });

    /* ========================================
       RESPONSIVE
    ======================================== */

    function updateSlideWidths() {
      const isMobile = window.innerWidth <= 749;

      slides.forEach(slide => {
        slide.style.setProperty(
          'flex',
          isMobile ? '0 0 85%' : '0 0 60%',
          'important'
        );
      });
    }

    window.addEventListener('resize', () => {
      updateSlideWidths();
      setPosition(false);
    }, { passive: true });

    /* ========================================
       IMAGE LOAD
    ======================================== */

    slides.forEach(slide => {
      const image = slide.querySelector('img');

      if (image && !image.complete) {
        image.addEventListener('load', () => {
          setPosition(false);
        }, { once: true });
      }
    });

    /* ========================================
       INITIALIZE
    ======================================== */

    updateSlideWidths();

    // レイアウト確定後に中央配置
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setPosition(false);
      });
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        setPosition(false);
      });
    }
  }

  /* ========================================
     BOOT
  ======================================== */

  function boot() {
    document
      .querySelectorAll('[data-arkt-journal]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();